import { NgModule } from '@angular/core';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { EnrollEmailDuplicateDirective } from './enroll-email-duplicate.directive';

@NgModule({
  imports: [AppMaterialModule],
  exports: [EnrollEmailDuplicateDirective],
  declarations: [EnrollEmailDuplicateDirective],
  providers: []
})
export class EnrollEmailDuplicateModule {}
